import { render } from "./GenproxButton.vue?vue&type=template&id=aba84cd0&scoped=true&ts=true"
import script from "./GenproxButton.vue?vue&type=script&lang=ts"
export * from "./GenproxButton.vue?vue&type=script&lang=ts"

import "./GenproxButton.vue?vue&type=style&index=0&id=aba84cd0&lang=postcss&scoped=true"
/* custom blocks */
import block0 from "./GenproxButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba84cd0"]])

export default __exports__